
// Get all clients
export const getClientsStart =()=>({
    type: "GET_CLIENTS_START",
});
export const getClientsSuccess =(clients)=>({
    type: "GET_CLIENTS_SUCCESS",
    payload: clients,
});
export const getClientsFailure =(error)=>({
    type: "GET_CLIENTS_FAILURE",
    payload: error,
});


// Add one client
export const addClientStart =()=>({
    type: "ADD_CLIENT_START",
});
export const addClientSuccess =(client)=>({
    type: "ADD_CLIENT_SUCCESS",
    payload: client,
});
export const addClientFailure =(error)=>({
    type: "ADD_CLIENT_FAILURE",
    payload: error,
});

// Update one client
export const updateClientStart =()=>({
    type: "UPDATE_CLIENT_START",
});
export const updateClientSuccess =(client)=>({
    type: "UPDATE_CLIENT_SUCCESS",
    payload: client,
});
export const updateClientFailure =(error)=>({
    type: "UPDATE_CLIENT_FAILURE",
    payload: error,
});

// Activate one client
export const activateClientStart =()=>({
    type: "ACTIVATE_CLIENT_START",
});
export const activateClientSuccess =(client)=>({
    type: "ACTIVATE_CLIENT_SUCCESS",
    payload: client,
});
export const activateClientFailure =(error)=>({
    type: "ACTIVATE_CLIENT_FAILURE",
    payload: error,
});